import React from 'react'
import _ from 'lodash'
import './RowLoader.scss'

interface IProps {
  columnCount: number
}

export function RowLoader(props: IProps) {
  const { columnCount = 0 } = props
  return (
    <tr>
      {_.times(columnCount, (i) => (
        <td key={`cell-loader_${i}`}>
          <div className="loader-cell loading-animation" />
        </td>
      ))}
    </tr>
  )
}
